var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h3", [_vm._v("Checklists")]),
    _vm._v(" "),
    _c("nav", [
      _c(
        "div",
        {
          staticClass: "nav nav-tabs",
          attrs: { id: "nav-tab", role: "tablist" },
        },
        [
          _vm.jmChecklist
            ? _c(
                "a",
                {
                  staticClass: "nav-item nav-link cp",
                  class: { active: _vm.tab == "tab1" },
                  on: {
                    click: function ($event) {
                      return _vm.setActiveTab("tab1")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n\t\t\t\t" + _vm._s(_vm.jmChecklist.name) + "\n\t\t\t"
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.submissionChecklist
            ? _c(
                "a",
                {
                  staticClass: "nav-item nav-link cp",
                  class: { active: _vm.tab == "tab2" },
                  on: {
                    click: function ($event) {
                      return _vm.setActiveTab("tab2")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.submissionChecklist.name) + "\n\t\t\t")]
              )
            : _vm._e(),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "tab-content", attrs: { id: "nav-tabContent" } }, [
      _vm.tab == "tab1"
        ? _c(
            "div",
            {
              staticClass: "tab-pane fade show",
              class: { active: _vm.tab == "tab1" },
              attrs: {
                id: "nav-home",
                role: "tabpanel",
                "aria-labelledby": "nav-home-tab",
              },
            },
            [
              _vm.jmChecklist
                ? _c(
                    "div",
                    { staticClass: "container-fluid" },
                    _vm._l(
                      _vm.jmChecklist.items,
                      function (checklistItem, checklistItemIndex) {
                        return _c(
                          "div",
                          { staticClass: "row py-2 jmChecklists" },
                          [
                            _c("div", { staticClass: "col-md-3" }, [
                              _c("p", [
                                _c("b", [_vm._v(_vm._s(checklistItem.value))]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-4" }, [
                              !checklistItem.completed_at
                                ? _c("textarea", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: checklistItem.completed_note,
                                        expression:
                                          "checklistItem.completed_note",
                                      },
                                    ],
                                    staticClass: "w-100",
                                    attrs: { type: "text" },
                                    domProps: {
                                      value: checklistItem.completed_note,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          checklistItem,
                                          "completed_note",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  })
                                : _c("p", [
                                    checklistItem.completed_note
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(checklistItem.completed_note)
                                          ),
                                        ])
                                      : _c("span", [
                                          _c("i", [
                                            _vm._v(
                                              "There was no comment specified."
                                            ),
                                          ]),
                                        ]),
                                  ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-5" }, [
                              !checklistItem.completed_at
                                ? _c(
                                    "button",
                                    {
                                      directives: [
                                        {
                                          name: "class",
                                          rawName: "v-class",
                                          value: {
                                            deactive:
                                              !checklistItem.completed_note,
                                          },
                                          expression:
                                            "{ deactive: !checklistItem.completed_note }",
                                        },
                                      ],
                                      on: {
                                        click: function ($event) {
                                          return _vm.completeChecklistItem(
                                            _vm.jmChecklist,
                                            checklistItem,
                                            checklistItemIndex
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Complete\n\t\t\t\t\t\t")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              checklistItem.completed_at
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "badge badge-success",
                                      staticStyle: {
                                        "font-size": "14px",
                                        "font-weight": "normal",
                                      },
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "mr-2 fa fa-check",
                                      }),
                                      _vm._v(
                                        " Completed at\n\t\t\t\t\t\t\t" +
                                          _vm._s(checklistItem.completed_at) +
                                          " by\n\t\t\t\t\t\t\t" +
                                          _vm._s(checklistItem.user.full_name)
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        )
                      }
                    ),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.jmChecklist
                ? _c("div", { staticClass: "container-fluid" }, [
                    _vm._v("\n\t\t\t\tJM Checklist Empty\n\t\t\t"),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tab == "tab2"
        ? _c(
            "div",
            {
              staticClass: "tab-pane fade show",
              class: { active: _vm.tab == "tab2" },
              attrs: {
                id: "nav-profile",
                role: "tabpanel",
                "aria-labelledby": "nav-profile-tab",
              },
            },
            [
              _vm.submissionChecklist.items.length
                ? _c(
                    "div",
                    { staticClass: "container-fluid" },
                    _vm._l(
                      _vm.submissionChecklist.items,
                      function (checklistItem, checklistItemIndex) {
                        return _c(
                          "div",
                          {
                            staticClass: "row py-2",
                            staticStyle: { border: "1px solid #efefef" },
                          },
                          [
                            _c("div", { staticClass: "col-md-3" }, [
                              _c("p", [
                                _c("b", [_vm._v(_vm._s(checklistItem.value))]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-4" }, [
                              !checklistItem.completed_at
                                ? _c("textarea", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: checklistItem.completed_note,
                                        expression:
                                          "checklistItem.completed_note",
                                      },
                                    ],
                                    staticClass: "w-100",
                                    attrs: { type: "text" },
                                    domProps: {
                                      value: checklistItem.completed_note,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          checklistItem,
                                          "completed_note",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  })
                                : _c("p", [
                                    _vm._v(
                                      _vm._s(checklistItem.completed_note)
                                    ),
                                  ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-md-5" }, [
                              !checklistItem.completed_at
                                ? _c(
                                    "button",
                                    {
                                      directives: [
                                        {
                                          name: "class",
                                          rawName: "v-class",
                                          value: {
                                            deactive:
                                              !checklistItem.completed_note,
                                          },
                                          expression:
                                            "{ deactive: !checklistItem.completed_note }",
                                        },
                                      ],
                                      on: {
                                        click: function ($event) {
                                          return _vm.completeChecklistItem(
                                            _vm.submissionChecklist,
                                            checklistItem,
                                            checklistItemIndex
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Complete\n\t\t\t\t\t\t")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              checklistItem.completed_at
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "badge badge-success",
                                      staticStyle: {
                                        "font-size": "14px",
                                        "font-weight": "normal",
                                      },
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "mr-2 fa fa-check",
                                      }),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\tCompleted at " +
                                          _vm._s(checklistItem.completed_at) +
                                          " by\n\t\t\t\t\t\t\t" +
                                          _vm._s(checklistItem.user.full_name)
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        )
                      }
                    ),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.submissionChecklist.items.length
                ? _c("div", { staticClass: "container-fluid" }, [
                    _vm._v("\n\t\t\t\tSubmission Checklist Empty\n\t\t\t"),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "separator" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }